import React from 'react';
import {Icon} from 'semantic-ui-react';
/* import {Checkbox} from 'semantic-ui-react'; */

export const renderCheckIcon = () => {
  return <Icon name='check circle' color='green' size='large' />;
};

export const renderCrossIcon = () => {
  return <Icon name='cancel' color='red' size='large' />;
};

const renderTableValue = (original, valueKey) => {
  if (original[valueKey]) {
    return (
      original.action === 'DELETE' ? <del>{original[valueKey]}</del> : original[valueKey]
    );
  }
  return null;
};

export const getColumns = ({
  maxVehiclesSelected,
  isOrderStatusNewOrIngressed,
  changeVehiclesArray,
}) => {
  return [
    {
      'Header': 'QUITAR',
      'accesor': 'sequence',
      'width': 65,
      'Cell': ({row}) => {
        const newAction = !row.original.action || row.original.action === 'INSERT' ? 'DELETE' : 'INSERT';
        if (isOrderStatusNewOrIngressed()) {
          return (
            <div style={{'textAlign': 'center'}}>
              <Icon name={newAction === 'INSERT' ? 'check' : 'trash'}
                disabled={newAction === 'INSERT' && maxVehiclesSelected()}
                size="large" style={{'cursor': 'pointer'}} className="input icon toyota-primary"
                onClick={() => {
                  newAction === 'INSERT' && maxVehiclesSelected() ?
                    null :
                    changeVehiclesArray(row.original, newAction);
                }} />
            </div>
          );
        }
        return null;
      },
    },
    {
      'Header': 'VEHÍCULO',
      'accessor': 'model',
      'width': 300,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'model');
      },
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'katashiki',
      'width': 150,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'katashiki');
      },
    },
    {
      'Header': 'SFX',
      'accessor': 'sfx',
      'width': 65,
      'Cell': ({row}) => {
        return <div style={{'textAlign': 'center'}}>{renderTableValue(row.original, 'sfx')}</div>;
      },
    },
    {
      'Header': 'CHASIS',
      'accessor': 'chassis',
      'width': 200,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'chassis');
      },
    },
    {
      'Header': 'CONC. DESTINO',
      'accessor': 'destinyDealer',
      'width': 250,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'destinyDealer');
      },
    },
    {
      'Header': 'AG. DESTINO',
      'accessor': 'agency',
      'width': 150,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'agency');
      },
    },
    {
      'Header': 'RESEVADO PARA',
      'accessor': 'reservedTo',
      'width': 250,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'reservedTo');
      },
    },
    {
      'Header': 'FACTURAR A',
      'accessor': 'invoiceTo',
      'width': 200,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'invoiceTo');
      },
    },
    {
      'Header': 'IMPORTADOR',
      'accessor': 'importer',
      'width': 200,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'importer');
      },
    },
    {
      'Header': 'Nº FACTURA',
      'accessor': 'vehOrder',
      'width': 100,
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'vehOrder');
      },
    },
    {
      'Header': 'UBICACIÓN',
      'accessor': 'location',
      'Cell': ({row}) => {
        return renderTableValue(row.original, 'location');
      },
    },
  ];
};
